import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Autocomplete, Box, Button, TextField, Typography } from '@mui/material'
import { fetchGetEmployers } from 'src/redux/employer'

const KioskEmployerStep = ({ wizardData, setWizardData, onNext, onBack }) => {
  const dispatch = useDispatch()
  const { employers = [] } = useSelector(state => state.employer)

  useEffect(() => {
    if (!employers.length) {
      dispatch(fetchGetEmployers())
    }
  }, [dispatch, employers.length])

  const employerOptions = employers.map(employer => ({ id: employer.id, name: employer.name }))

  const selectedOption = wizardData.employerId
    ? employerOptions.find(opt => opt.id === wizardData.employerId) || null
    : null

  const inputValue = wizardData.employerName || ''

  const isNextEnabled = wizardData.employerId || (wizardData.employerName || '').trim().length >= 2

  const handleChange = (event, value) => {
    if (value && typeof value === 'object') {
      setWizardData(prev => ({ ...prev, employerId: value.id, employerName: value.name }))
    } else if (typeof value === 'string') {
      setWizardData(prev => ({ ...prev, employerId: null, employerName: value }))
    } else {
      setWizardData(prev => ({ ...prev, employerId: null, employerName: '' }))
    }
  }

  const handleInputChange = (event, value, reason) => {
    if (reason === 'input') {
      setWizardData(prev => ({ ...prev, employerId: null, employerName: value }))
    }
  }

  return (
    <Box>
      <Typography variant='h5' gutterBottom>
        Select or Enter Employer
      </Typography>
      <Typography variant='body2' color='text.secondary' sx={{ mb: 3 }}>
        Choose an existing employer or type a new name to create one.
      </Typography>
      <Autocomplete
        freeSolo
        options={employerOptions}
        getOptionLabel={option => (typeof option === 'string' ? option : option.name)}
        value={selectedOption}
        inputValue={inputValue}
        onChange={handleChange}
        onInputChange={handleInputChange}
        renderInput={params => (
          <TextField
            {...params}
            label='Employer'
            placeholder='Search or type employer name'
            fullWidth
          />
        )}
      />
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
        <Button onClick={onBack}>Back</Button>
        <Button variant='contained' onClick={onNext} disabled={!isNextEnabled}>
          Next
        </Button>
      </Box>
    </Box>
  )
}

export default KioskEmployerStep
